import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import image1 from './assets/image1.png';
import image2 from './assets/image2.png';
import image3 from './assets/image3.png';
import image4 from './assets/image4.png';
import './css/CreatorsScreen.css';

function CreatorsScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const raw = localStorage.getItem('savory_creator');
      if (!raw) return;
      const session = JSON.parse(raw);
      if (session && session.email) navigate('/creators/dashboard', { replace: true });
    } catch {}
  }, [navigate]);

  return (
    <div className="creators-screen">
      <div className="creators-screen-bg" aria-hidden="true">
        <img src={image1} alt="" className="creators-bg-img creators-bg-img-1" />
        <img src={image2} alt="" className="creators-bg-img creators-bg-img-2" />
        <img src={image3} alt="" className="creators-bg-img creators-bg-img-3" />
        <img src={image4} alt="" className="creators-bg-img creators-bg-img-4" />
      </div>
      <div className="creators-container">
        <h1 className="creators-title">Creators</h1>
        <p className="creators-subtitle">
          Share your recipes with the world or sign in to manage your creator account
        </p>

        <div className="creators-paths">
          <motion.div
            className="creator-path-card creator-path-card-become"
            whileHover={{ y: -2 }}
            transition={{ duration: 0.2 }}
          >
            <div className="become-card-inner">
              <h2 className="become-card-title">Become a creator</h2>
              <p className="become-card-subtitle">Contact us to get started.</p>
              <div className="become-contact-channels">
                <a
                  href="https://www.instagram.com/savory.ink/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="become-contact-channel"
                >
                  <span className="become-channel-icon" aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/>
                      <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/>
                      <circle cx="18" cy="6" r="1.5" fill="currentColor"/>
                    </svg>
                  </span>
                  <span className="become-channel-label">Instagram</span>
                  <span className="become-channel-value">@savory.ink</span>
                </a>
                <a href="mailto:team@savory.ink" className="become-contact-channel">
                  <span className="become-channel-icon" aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </span>
                  <span className="become-channel-label">Email</span>
                  <span className="become-channel-value">team@savory.ink</span>
                </a>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="creator-path-card"
            whileHover={{ scale: 1.02, y: -4 }}
            transition={{ duration: 0.2 }}
          >
            <Link to="/creators/login" className="creator-path-link">
              <div className="creator-path-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M10 17L15 12L10 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M15 12H3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h2 className="creator-path-title">Creator login</h2>
              <p className="creator-path-description">
                Sign in to manage your recipes and creator profile. Access your dashboard and grow your audience.
              </p>
              <span className="creator-path-cta">Sign in →</span>
            </Link>
          </motion.div>
        </div>
      </div>
    </div>
  );
}

export default CreatorsScreen;
